import React from 'react'
import { VictoryChart, VictoryStack, VictoryGroup, VictoryArea } from 'victory'
import { Container } from './styles'

const DiscontinuousScale = ({ dataScale }) => {
  return (
    <Container>
      <VictoryChart
        scale={{ x: 'time' }}
        animate={{
          duration: 2000,
          easing: 'linear',
          onLoad: { duration: 1000 }
        }}
        height={300}
      >
        <VictoryStack colorScale="qualitative">
          <VictoryGroup data={dataScale}>
            <VictoryArea
              style={{ data: { fill: '#f5cfa2', stroke: '#BE9137' } }}
            />
          </VictoryGroup>
        </VictoryStack>
      </VictoryChart>
    </Container>
  )
}

export default DiscontinuousScale
